import { ApiClient } from '../helpers/api-client/ApiClient'
import { AuthAcceptMethods } from '../enums/AuthAcceptMethods'
import { ResponseStatuses } from '../../enums/ResponseStatuses'

export default function acceptLogin ({ to, next, store }) {
  const form = {
    accept_method: AuthAcceptMethods.Email,
    accept_token: to.query.accept_token
  }

  return ApiClient.acceptLogin(form)
    .then(async (response) => {
      const data = response.data

      if (data.status === ResponseStatuses.Success) {
        store.dispatch('authorize', data.data)

        return next('/')
      }

      const query = {}
      if (response.status === 403 && response.data.message) {
        query.error = response.data.message;
        query._t = Date.now()
      }

      return next({
        path: '/login',
        query
      })
    })
}
